import React from 'react';
import ShoppingCart from '@tamagoshi/core/cjs/iconsSystem/ShoppingCart';
import PropTypes from 'prop-types';

const BasketB2B = ({ size }) => <ShoppingCart height={size} width={size} />;

BasketB2B.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

BasketB2B.defaultProps = {
  size: 24,
};

export default BasketB2B;
